import { omit } from 'lodash'

import { IDaveAuthenticatedUser } from 'modules/Monitoring/types/generated/idave-authenticated-user'

type WhoAmIResponseUserWithoutRoles = Omit<IDaveAuthenticatedUser, 'roles'>

const extractUserPermissions = (userDetails: IDaveAuthenticatedUser): string[] =>
  userDetails.permissions?.map(permission => permission) ?? []

const extractUserRoles = (userDetails: IDaveAuthenticatedUser) =>
  userDetails.roles?.map(role => role) ?? []

export const AuthenticatedUser = (() => {
  let user = {} as WhoAmIResponseUserWithoutRoles
  let permissions: string[] = []
  let roles: string[] = []

  return {
    get id() {
      return user.id
    },

    get email() {
      return user.email
    },

    get firstName() {
      return user.firstName
    },

    get lastName() {
      return user.lastName
    },

    get permissions() {
      return permissions
    },

    get roles() {
      return roles
    },

    setUser(userDetails: IDaveAuthenticatedUser) {
      user = omit(userDetails, 'roles')
      roles = extractUserRoles(userDetails)
      permissions = extractUserPermissions(userDetails)
    },
  } as const
})()
